<template>
  <section class="related-products container">
    <h2>{{ relatedProducts.title }}</h2>
    <swiper
      :navigation="swiperOptions.navigation"
      :modules="modules"
      class="related-products-swiper position-relative"
      :slides-per-view="swiperOptions.slidesPerView"
      :space-between="swiperOptions.spaceBetween"
      :breakpoints="swiperOptions.breakpoints"
    >
      <swiper-slide v-for="card in relatedProducts.cards">
        <ProductCard :card="card"/>
      </swiper-slide>
    </swiper>
    <div class="d-flex justify-content-center contact-btn">
      <ButtonRed
        v-if="relatedProducts.contactButton.showModalButton"
        :text="relatedProducts.contactButton.title"
        @click="handleModal"
      />
    </div>
    <ModalForm
      :modal="relatedProducts.contactButton.modal"
      :successModalData="relatedProducts.contactButton.successModal"
      :show="showModal"
      @handleModal="handleModal"
    />
  </section>
</template>

<script setup>
import {Swiper, SwiperSlide} from "swiper/vue";
import {Navigation} from "swiper";
import ProductCard from "@/components/application-details/ProductCard";
import ButtonRed from "@/components/common/ButtonRed";
import ModalForm from "@/components/common/modals/ModalForm.vue";
import {ref} from "vue";

defineProps({
  relatedProducts: {
    title: String,
    cards: Array,
    contactButton: {
      title: String,
      showModalButton: String,
      modal: Object,
      successModal: Object
    }
  }
})

const modules = [Navigation];
const swiperOptions = {
  slidesPerView: 1,
  spaceBetween: 20,
  breakpoints: {
    580: {
      slidesPerView: 2
    },
    992: {
      slidesPerView: 3
    },
  },
  modules: [Navigation],
  navigation: true
}

const showModal = ref(false);
const handleModal = () => showModal.value = !showModal.value;

</script>
